import { Injectable } from '@angular/core';
import { BatchAuftragDetailEntryMeta, BatchAuftragService } from '../../../../core/batch-auftrag-api';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ResolverValidationExceptionHandler } from '../../../../core/extension/exceptions/exception-handler-rule';
import { CapExceptionHandler } from '../../../../core/extension/exceptions/cap-exception-handler';

@Injectable()
export class AuftragDetailResolver {
  constructor(
    private auftragService: BatchAuftragService,
    private resolverExceptionHandler: ResolverValidationExceptionHandler,
    private exceptionHandler: CapExceptionHandler
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<BatchAuftragDetailEntryMeta> | Promise<BatchAuftragDetailEntryMeta> | BatchAuftragDetailEntryMeta {
    const id = route.queryParamMap.get('id');
    return this.auftragService.loadBatchAuftragDetailEntryById(id).pipe(
      catchError((err) => {
        if (this.resolverExceptionHandler.errorHandled(err)) {
          return EMPTY;
        }
        this.exceptionHandler.handleError(err);
        return EMPTY;
      })
    );
  }
}
